import { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { EFinancingOfferRoute } from '@/types'

export const FINANCING_PRODUCTS_MFO: FundingProduct[] = [FundingProduct.AGROINTEGRATOR, FundingProduct.MONEY_KAPITAL]

export const FINANCING_PRODUCT_BY_ROUTE: Partial<Record<EFinancingOfferRoute, FundingProduct>> = {
  [EFinancingOfferRoute.MFOPage]: FundingProduct.EXPRESS_MFO,
  [EFinancingOfferRoute.FinancingAgentPage]: FundingProduct.AGENT,
  [EFinancingOfferRoute.oborotSber]: FundingProduct.REVOLVING_LOAN_SBER,
  [EFinancingOfferRoute.centerInvestLoan]: FundingProduct.CENTER_INVEST_LOAN,
  [EFinancingOfferRoute.investSber]: FundingProduct.SBER_INVESTMENT_LOAN,
  [EFinancingOfferRoute.advancePaymentOnFutureHarvest]: FundingProduct.ADVANCE_FUNDING,
  [EFinancingOfferRoute.sberLeasing]: FundingProduct.SBER_LEASING,
  [EFinancingOfferRoute.interleasing]: FundingProduct.LEASING_INTERLEASING,
  [EFinancingOfferRoute.agriculturalMachinesAndEquipmentLeasing]: FundingProduct.LEASING_RAL,
  [EFinancingOfferRoute.fleetFinanceLeasing]: FundingProduct.LEASING_FLEET_FINANCE,
}
